import api from "../api/axiosConfig";

const authService = {
  getMe: () => api.get("/me"),
};

export default authService;
